import React from "react";
import ProjectList from "../components/Apps/Fuse/projectList/ProjectList";
import { CssBaseline } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Fuse = () => {
  const navigate = useNavigate();

  return (
    <div>
      <ProjectList navigate={navigate} />
    </div>
  );
};

export default Fuse;
